"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MaxPartitionsRange = exports.splitPartitionsCountIntoQueryPartitionRanges = exports.splitPartitionsCountIntoChunks = exports.getSharedFunctionDataPrincipal = exports.ICRestError = exports.getICFirstKey = exports.getICRequestErrName = exports.isICRequestErrWithName = exports.isICRequestErr = exports.isICRequestOk = exports.USERS_PARTITIONS_COUNT = void 0;
const typescriptAddons_1 = require("src/hello_assets/src/util/typescriptAddons");
exports.USERS_PARTITIONS_COUNT = 1024;
const okResultKey = "ok";
const errResultKey = "err";
const isICRequestOk = (obj) => {
    return (0, typescriptAddons_1.hasOwnProperty)(obj, okResultKey);
};
exports.isICRequestOk = isICRequestOk;
const isICRequestErr = (obj) => {
    return (0, typescriptAddons_1.hasOwnProperty)(obj, errResultKey);
};
exports.isICRequestErr = isICRequestErr;
const isICRequestErrWithName = (obj, name) => {
    return (0, typescriptAddons_1.hasOwnProperty)(obj, name);
};
exports.isICRequestErrWithName = isICRequestErrWithName;
const getICRequestErrName = (obj) => {
    // @ts-ignore
    return Object.keys(obj[errResultKey])[0];
};
exports.getICRequestErrName = getICRequestErrName;
/*export const getICFirstKey = <T>(obj: T): string => {
    return Object.keys(obj)[0]
}*/
const getICFirstKey = (obj) => {
    // @ts-ignore
    return Object.keys(obj)[0];
};
exports.getICFirstKey = getICFirstKey;
class ICRestError {
    constructor(message) {
        this.toString = () => {
            return `ICRestError (message: ${this.message})`;
        };
        this.message = message;
    }
    static withUnknownError(e) {
        const error = e instanceof ICRestError ? e : ICRestError.withNativeError(e);
        return error;
    }
    static withNativeError(error) {
        return new ICRestError(error.message);
    }
    toNativeError() {
        return new Error(this.message);
    }
}
exports.ICRestError = ICRestError;
const getSharedFunctionDataPrincipal = (value) => {
    try {
        if (Array.isArray(value)) {
            const data = value;
            if (data.length === 2) {
                const principal = data[0];
                if (typeof principal["toText"] != "function") {
                    console.warn("util.getSharedFunctionDataPrincipal: bad principal object", principal);
                }
                return principal;
            }
        }
    }
    catch (e) {
        console.warn("util.getSharedFunctionDataPrincipal", e);
    }
    return undefined;
};
exports.getSharedFunctionDataPrincipal = getSharedFunctionDataPrincipal;
const splitPartitionsCountIntoChunks = (numberOfChunks, partitionsCount) => {
    if (numberOfChunks <= 0) {
        throw new Error(`Bad number of partition chunks. Must be even and positive! (passed value is ${numberOfChunks})`);
    }
    const length = Math.ceil(partitionsCount / numberOfChunks);
    const result = [];
    for (let i = 0; i < numberOfChunks; i++) {
        const rangeStart = Math.min(Math.max(0, length * i), partitionsCount);
        let rangeLength = Math.min(Math.max(1, length), partitionsCount);
        let shouldBreak = false;
        if (rangeStart + rangeLength > partitionsCount) {
            rangeLength = partitionsCount - rangeStart;
            shouldBreak = true;
        }
        if (rangeLength > 0) {
            result.push({ start: rangeStart, length: rangeLength });
        }
        if (shouldBreak) {
            break;
        }
    }
    return result;
};
exports.splitPartitionsCountIntoChunks = splitPartitionsCountIntoChunks;
const splitPartitionsCountIntoQueryPartitionRanges = (numberOfChunks, partitionsCount) => {
    if (numberOfChunks <= 0) {
        throw new Error(`Bad number of partition chunks. Must be even and positive! (passed value is ${numberOfChunks})`);
    }
    const length = Math.ceil(partitionsCount / numberOfChunks);
    const result = [];
    for (let i = 0; i < numberOfChunks; i++) {
        const rangeStart = Math.min(Math.max(0, length * i), partitionsCount);
        let rangeLength = Math.min(Math.max(1, length), partitionsCount);
        let shouldBreak = false;
        if (rangeStart + rangeLength > partitionsCount) {
            rangeLength = partitionsCount - rangeStart;
            shouldBreak = true;
        }
        if (rangeLength > 0) {
            result.push({
                start: rangeStart,
                length: rangeLength
            });
        }
        if (shouldBreak) {
            break;
        }
    }
    return result;
};
exports.splitPartitionsCountIntoQueryPartitionRanges = splitPartitionsCountIntoQueryPartitionRanges;
exports.MaxPartitionsRange = { start: 0, length: exports.USERS_PARTITIONS_COUNT };
